// import { Link } from 'react-router-dom';

const ApproachSection = () => {
  return (
    <section className="py-12 md:py-24 bg-gray-900" style={{ backgroundColor: '#0f1b3c', padding: '3rem 0' }}>
      <div className="container mx-auto px-4" style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 1rem' }}>
        <div className="max-w-7xl mx-auto" style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start' }}>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-start" style={{ width: '100%', maxWidth: '1400px', gap: '2rem' }}>
            
            {/* Left Column - Main Content */}
            <div className="text-white" style={{ paddingRight: '0' }}>
              {/* Header */}
              <div className="mb-8 md:mb-12" style={{ marginBottom: '2rem' }}>
                <h3 
                  className="text-sm md:text-lg font-normal mb-4 md:mb-6" 
                  style={{ 
                    fontSize: '0.875rem', 
                    letterSpacing: '0.05em', 
                    marginBottom: '1rem',
                    color: '#ffffff'
                  }}
                >
                  Consideration for the Prize
                </h3>
                <h2 
                  className="text-2xl md:text-4xl lg:text-5xl font-bold mb-6 md:mb-8 leading-tight" 
                  style={{ 
                    fontSize: 'clamp(1.5rem, 4vw, 3rem)', 
                    lineHeight: '1.2', 
                    fontWeight: '700', 
                    marginBottom: '1.5rem',
                    color: '#ffffff'
                  }}
                >
                  EXCELLENCE IN<br />
                  DIGITAL INNOVATION &<br />
                  AND TRANSFORMATION
                </h2>
              </div>

              {/* Description */}
              <div className="mb-8 md:mb-12" style={{ marginBottom: '2rem' }}>
                <p className="text-base md:text-lg text-gray-300 leading-relaxed mb-4 md:mb-6" style={{ fontSize: 'clamp(0.875rem, 2vw, 1.05rem)', lineHeight: '1.8', color: '#d1d5db', marginBottom: '1rem' }}>
                  The Tanzania Digital Awards evaluates nominees through a comprehensive lens of excellence, 
                  innovation, and impact. Our selection process focuses on groundbreaking solutions that 
                  demonstrate exceptional creativity, measurable outcomes, and sustainable transformation 
                  across Tanzania's digital landscape.
                </p>
                <p className="text-base md:text-lg text-gray-300 leading-relaxed mb-6 md:mb-8" style={{ fontSize: 'clamp(0.875rem, 2vw, 1.05rem)', lineHeight: '1.8', color: '#d1d5db' }}>
                  We recognize visionaries who not only embrace technological advancement but also create 
                  meaningful change in their respective sectors and communities.
                </p>
              </div>

              {/* Learn More Button */}
              {/* <div className="flex items-center space-x-4" style={{ marginTop: '3rem' }}>
                <Link to="/about" className="flex items-center space-x-4 group">
                  <span className="text-lg font-medium text-white uppercase tracking-wide" style={{ fontSize: '0.95rem', letterSpacing: '0.1em' }}>LEARN MORE</span>
                  <button className="w-14 h-14 border-2 border-white rounded-full flex items-center justify-center hover:bg-white hover:text-gray-900 transition-all duration-300 group-hover:scale-110">
                    <i className="fa-solid fa-arrow-up-right text-sm"></i>
                  </button>
                </Link>
              </div> */}
            </div>

            {/* Right Column - Three Cards with White Background and Dark Blue Text */}
            <div className="space-y-6 md:space-y-8" style={{ paddingLeft: '0', marginBottom: '2rem', display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
              
              {/* Card 01 - Contribution to Society */}
              <div className="bg-white rounded-2xl p-6 md:p-10 shadow-xl hover:shadow-2xl transition-all duration-300" style={{ borderRadius: '20px', boxShadow: '0 10px 30px rgba(0,0,0,0.3)', padding: '1.5rem', backgroundColor: '#ffffff' }}>
                <div className="mb-4 md:mb-6" style={{ marginBottom: '1rem' }}>
                  <h3 className="text-lg md:text-2xl font-bold text-gray-900 mb-4 md:mb-6 uppercase tracking-wide" style={{ fontSize: 'clamp(1rem, 2vw, 1.25rem)', fontWeight: '700', letterSpacing: '0.05em', marginBottom: '1rem', color: '#0f1b3c' }}>
                    CONTRIBUTION TO THE SOCIETY
                  </h3>
                </div>
                <p className="text-gray-700 leading-relaxed text-sm md:text-lg" style={{ lineHeight: '1.8', fontSize: 'clamp(0.875rem, 2vw, 1rem)', color: '#374151' }}>
                  Programs, efforts, and initiatives with significant contributions that have conferred 
                  the greatest benefit to humanity, that inspire actions, bring change, and foster 
                  long-term impact across and beyond online communities using and through digital 
                  platforms and technologies.
                </p>
              </div>

              {/* Card 02 - Creativity */}
              <div className="bg-white rounded-2xl p-6 md:p-10 shadow-xl hover:shadow-2xl transition-all duration-300" style={{ borderRadius: '20px', boxShadow: '0 10px 30px rgba(0,0,0,0.3)', padding: '1.5rem', backgroundColor: '#ffffff' }}>
                <div className="mb-4 md:mb-6" style={{ marginBottom: '1rem' }}>
                  <h3 className="text-lg md:text-2xl font-bold text-gray-900 mb-4 md:mb-6 uppercase tracking-wide" style={{ fontSize: 'clamp(1rem, 2vw, 1.25rem)', fontWeight: '700', letterSpacing: '0.05em', marginBottom: '1rem', color: '#0f1b3c' }}>
                    CREATIVITY
                  </h3>
                </div>
                <p className="text-gray-700 leading-relaxed text-sm md:text-lg" style={{ lineHeight: '1.8', fontSize: 'clamp(0.875rem, 2vw, 1rem)', color: '#374151' }}>
                  Programs, projects, and initiatives that have addressed socioeconomic concerns and 
                  individual challenges creatively while demonstrating the potential for development, 
                  scalability, and a larger influence in achieving a digitally transformed Tanzania.
                </p>
              </div>

              {/* Card 03 - Innovation */}
              <div className="bg-white rounded-2xl p-6 md:p-10 shadow-xl hover:shadow-2xl transition-all duration-300" style={{ borderRadius: '20px', boxShadow: '0 10px 30px rgba(0,0,0,0.3)', padding: '1.5rem', backgroundColor: '#ffffff' }}>
                <div className="mb-4 md:mb-6" style={{ marginBottom: '1rem' }}>
                  <h3 className="text-lg md:text-2xl font-bold text-gray-900 mb-4 md:mb-6 uppercase tracking-wide" style={{ fontSize: 'clamp(1rem, 2vw, 1.25rem)', fontWeight: '700', letterSpacing: '0.05em', marginBottom: '1rem', color: '#0f1b3c' }}>
                    INNOVATION
                  </h3>
                </div>
                <p className="text-gray-700 leading-relaxed text-sm md:text-lg" style={{ lineHeight: '1.8', fontSize: 'clamp(0.875rem, 2vw, 1rem)', color: '#374151' }}>
                  Implementation of ideas and initiatives resulting in the introduction of new goods 
                  or services or improvements in the delivery of goods or services in the public, 
                  private, and development sectors. This could include better governance, service 
                  delivery, and business-model innovations that positively impact the economy, 
                  businesses, job generation, and overall contribution to local and national growth.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ApproachSection;
